import {
  DataFromStorageSetter,
  IPendingConfigStorage,
  ISettingsStorage,
} from "@/services/storage/base/storage-abstractions";
import { StemSplitterConfig } from "@/components/pages/stem-splitter/hooks/use-start-splitter";
import { PendingConfigStorageMixin } from "@/services/storage/storage-mixins/pending-config-storage-mixin";
import { StemSplitterSettingsStorageMixin } from "@/services/storage/storage-mixins/settings-mixins/stem-splitter-settings-storage-mixin";
import React from "react";
import {
  initialSelectedCategories,
  StemSplitterSettings,
} from "@/components/pages/stem-splitter/components/providers/stem-splitter-provider";
import { MediaInputStorage } from "@/services/storage/base/media-input-storage";

export type StemSplitterSettingsField = "category";

class StemSplitterSessionStorage
  extends MediaInputStorage
  implements
    IPendingConfigStorage<StemSplitterConfig>,
    ISettingsStorage<StemSplitterSettingsField>,
    DataFromStorageSetter<StemSplitterSettings>
{
  constructor() {
    super("splitterCache", "StemSplitterDB");
  }

  pendingConfigStorage = new PendingConfigStorageMixin<StemSplitterConfig>(
    this.storeName,
    this.databaseName,
  );
  settingStorage = new StemSplitterSettingsStorageMixin(
    this.storeName,
    this.databaseName,
  );

  async setDataFromStorage(
    setSettings: (value: React.SetStateAction<StemSplitterSettings>) => void,
  ): Promise<void> {
    const sessionSettings = await this.settingStorage.getSettings();

    setSettings((prevState) => ({
      ...prevState,
      selectedCategories:
        sessionSettings.category?.length > 0
          ? sessionSettings.category
          : initialSelectedCategories,
    }));
  }
}

const stemSplitterSessionStorage = new StemSplitterSessionStorage();
export { stemSplitterSessionStorage };
